import styled from 'styled-components'
import { color, fontSize, fontWeight, injectModifiers } from 'ui/themes/utils'
import modifiers from 'ui/themes/modifiers'

const H2 = styled.h2`
  margin: 0;

  color: ${color('Text/Primary')};
  font-size: ${fontSize('xl')};
  font-weight: ${fontWeight('semibold')};

  ${({ theme }) => injectModifiers(modifiers(theme))}
`

export default H2
